import base from '../base/base';
import header from '../base/header';



// WEBPACK FOOTER //
// ./assets/layouts/page/page.js